import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {Organisation, Organisation_paiement, Organisation_paiement_orga_detail} from "../types/organisation";
import {Zone} from "../types/zone";
import {All_permissions} from "../types/permissions";
import {Capteur} from "../types/capteur";
import {Hub} from "../types/hub";
import {store} from "./store";
import env_config from "../env_config";
import {Regle_paiement, regles_par_defaut} from "../types/regle_paiement";

export type Orga_state = {
    lastMiseAJour: number,
    list: Organisation[],
    bandeau_top:bandeauTopAffichage
    regles_paiement_defaut: Regle_paiement
}

const initial_state:Orga_state = {
    lastMiseAJour: 0,
    list: [],
    bandeau_top: {
        texte: "",
        user_close_it: false
    },
    regles_paiement_defaut: regles_par_defaut
};

export type bandeauTopAffichage = {
    texte: string
    user_close_it: boolean
}
export const organisationSlice = createSlice({
    name: "organisation",
    initialState:initial_state as Orga_state,
    reducers: {
        addOrganisations: (state, action:PayloadAction<{message:string, organisations:Organisation[]}>) => {
            state.lastMiseAJour = Date.now();
            action.payload.organisations.map(organisation => {
                if (organisation.permissions?.includes("ADMIN"))
                {
                    All_permissions.filter(p => p.categorie !== "Cycle").map(p => organisation.permissions?.push(p.slug));
                    organisation.permissions.push("ADMIN")
                }

                return organisation
            })
            state.list = action.payload.organisations;
            return state;
        },
        editOrganisation: (state, action:PayloadAction<Organisation>) => {
            state.lastMiseAJour = Date.now();
            state.list = state.list.map(orga => {
                if (orga.id === action.payload.id)
                {
                    return action.payload
                }
                return orga;
            })
            return state;
        },
        clearOrganisations: (state, action:PayloadAction<void>) => {
            return initial_state;
        },
        addZonesToOrganisation: (state, action:PayloadAction<{id_orga: number, zones: Zone[], capteurs: Capteur[], hubs:Hub[]}>) => {
            state.list = state.list.map(organisation => {
                if (organisation.id === action.payload.id_orga){
                    let _zones = action.payload.zones;
                    _zones = _zones.map(z => {
                        organisation.zones?.map(zo => {
                            if (z.id === zo.id) z.cellules_minimum = zo.cellules_minimum;
                        })
                        return z;
                    })
                    organisation.zones = _zones;
                    organisation.capteurs = action.payload.capteurs;
                    organisation.hubs = action.payload.hubs;
                }
                organisation.is_fully_loaded = true;
                return organisation
            })

            if (!state.bandeau_top.user_close_it && state.list.filter(o => o.etat === "New" && o.prochainPrelevement && o.balance <= 0).length > 0) {
                state.bandeau_top.texte = env_config.texte_bandeau_affichage_paiement
            }

            return state;
        },
        setRegles_paiement_defaut: (state, action:PayloadAction<Regle_paiement>) => {

            state.regles_paiement_defaut = action.payload
            return state

        },
        setBandeauAffichageTexte: (state, action:PayloadAction<string>) => {

            state.bandeau_top.texte = action.payload
            return state

        },
        setBandeauAffichageTextePaiementDemain: (state, action:PayloadAction<void>) => {
            if (!state.bandeau_top.user_close_it && state.list.filter(o => o.etat === "New" && o.prochainPrelevement && o.balance <= 0).length > 0) {
                state.bandeau_top.texte = env_config.texte_bandeau_affichage_paiement
            }
            return state
        },
        setBandeauAffichageEffacer: (state, action:PayloadAction<void>) => {

            state.bandeau_top.texte = ""
            state.bandeau_top.user_close_it = true;
            return state
        },
        majSimpleOrganisation: (state, action:PayloadAction<Organisation|Organisation_paiement_orga_detail>) => {

            state.lastMiseAJour = Date.now();
            state.list = state.list.map(orga => {
                if (orga.id === action.payload.id)
                {
                    let orga_edit:Organisation = {...orga}
                    if ("credit_SMS" in action.payload) orga_edit.credit_SMS = action.payload.credit_SMS;
                    if ("credit_Tel" in action.payload) orga_edit.credit_Tel = action.payload.credit_Tel;
                    if ("balance" in action.payload) orga_edit.balance = action.payload.balance;
                    if ("cBLabel" in action.payload) orga_edit.cBLabel = action.payload.cBLabel;
                    if ("cBPerime" in action.payload) orga_edit.cBPerime = action.payload.cBPerime;
                    if ("etat" in action.payload) orga_edit.etat = action.payload.etat;
                    if ("prochainPrelevement" in action.payload) orga_edit.prochainPrelevement = action.payload.prochainPrelevement;
                    if ("regles_paiements" in action.payload) orga_edit.regles_paiements = action.payload.regles_paiements;
                    if ("nom" in action.payload) orga_edit.nom = action.payload.nom;
                    if ("desactivation_texte" in action.payload) orga_edit.desactivation_texte = action.payload.desactivation_texte;
                    if ("orga_parent" in action.payload) orga_edit.orga_parent = action.payload.orga_parent;
                    return orga_edit
                }
                return orga;
            })
            return state;
        },
    }
})

export const {addOrganisations, editOrganisation, clearOrganisations, addZonesToOrganisation,
    setBandeauAffichageTexte,
    setBandeauAffichageTextePaiementDemain,
    majSimpleOrganisation,
    setRegles_paiement_defaut,
    setBandeauAffichageEffacer,} = organisationSlice.actions;
